import React, { useState, useEffect } from "react";
import { WordCloud } from "@ant-design/charts";
import { DATA } from "../../../myanfinviz";
import * as _ from "lodash";
export const LandOwnerWordCloud = () => {
  var newData = _.groupBy(DATA, (r) => r["Land Owner"]);
  // newData = _.orderBy(newData, (r) => r.length, "desc");
  console.log("LandOwnerWordCloud data before", newData);

  newData = _.mapValues(newData, (r) => {
    return { name: r[0]["Land Owner"], value: r.length };
  });
  newData = _.orderBy(newData, (r) => r.value, "desc");
  console.log("LandOwnerWordCloud data", newData);
  newData = _.filter(newData, (r) => {
    return r.name != "-" && r.name != "";
  });
  newData = _.chunk(newData, 40);

  newData = _.filter(newData[0], (r) => {
    return r.name != "-" && r.name != "";
  });

  console.log("LandOwnerWordCloud filtered", newData);
  var config = {
    data: [...newData],
    wordField: "name",
    weightField: "value",
    color: "#122c6a",
    wordStyle: {
      fontFamily: "Verdana",
      fontSize: [24, 80],
    },
    interactions: [{ type: "element-active" }],
    state: { active: { style: { lineWidth: 3 } } },
  };

  return <WordCloud {...config} />;
};
